export default __webpack_public_path__ + "static/softwareconsult3-00f2c5ff54a0bdbbd9d07ffdeddbeff9.jpg";